import(/* webpackMode: "eager", webpackExports: ["PrismeProvider"] */ "/builds/PortailVente/portailvente_web_wall/nextweb/node_modules/@bytel/logger-nextjs/dist/client.js");
;
import(/* webpackMode: "eager" */ "/builds/PortailVente/portailvente_web_wall/nextweb/node_modules/next-runtime-env/build/provider/env-provider.js");
;
import(/* webpackMode: "eager" */ "/builds/PortailVente/portailvente_web_wall/nextweb/node_modules/next-runtime-env/build/provider/use-env-context.js");
;
import(/* webpackMode: "eager" */ "/builds/PortailVente/portailvente_web_wall/nextweb/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/builds/PortailVente/portailvente_web_wall/nextweb/src/app/(home-pack)/_assets/style.css");
;
import(/* webpackMode: "eager" */ "/builds/PortailVente/portailvente_web_wall/nextweb/src/app/(home-pack)/_components/pack-body.tsx");
;
import(/* webpackMode: "eager" */ "/builds/PortailVente/portailvente_web_wall/nextweb/src/app/(home-pack)/_components/pack.tsx");
;
import(/* webpackMode: "eager" */ "/builds/PortailVente/portailvente_web_wall/nextweb/src/app/(home-pack)/_components/product-card.tsx");
;
import(/* webpackMode: "eager" */ "/builds/PortailVente/portailvente_web_wall/nextweb/src/app/(home-pack)/_components/product-filters.tsx");
;
import(/* webpackMode: "eager" */ "/builds/PortailVente/portailvente_web_wall/nextweb/src/app/(home-pack)/_components/sticky-bar.tsx");
;
import(/* webpackMode: "eager" */ "/builds/PortailVente/portailvente_web_wall/nextweb/src/app/(home-pack)/_components/tabs.tsx");
